import { Util } from '@/modules/util'
import { Request } from '@/classes/Request'

// POST /ajax/account_settings/update_email
export const updateEmail = async (payload: Object): Promise<any> => {
  return new Promise((resolve, reject) => {
    const req = new Request()
    req
      .post('/ajax/account_settings/update_email', payload)
      .then((response: any) => {
        resolve(Util.Obj.keysToCamel(response.data))
      })
      .catch((err: any) => {
        reject(err.responseText)
      })
  })
}
